import { get } from "react-hook-form";
import { getFormInstance } from "../repositories/FormsRepository";
import { useFormsContext } from "../context/formsContext";
import { getGroupedInstance } from "../helpers/getGroupedInstance";

export const useGetSelectedInstance = () => {
	const {
		state: { selectedInstanceId },
		actions: {
			setFormInstanceRows,
			setFormInstanceSections,
			setFormInstanceQuestions,
			setLayoutCode,
		},
	} = useFormsContext();

	return () => {
		if (
			selectedInstanceId === null ||
			selectedInstanceId === undefined ||
			!selectedInstanceId
		)
			return;
		getFormInstance(selectedInstanceId).then((res) => {
			if (res) {
				const instanceRows = get(res, "data", null);
				const instanceTable = instanceRows?.tables[0];

				if (instanceTable?.rows.length === 0) return;
				const { formInstance, groupedSections, groupedQuestions } =
					getGroupedInstance(instanceTable.rows);

				setFormInstanceRows(formInstance);
				setFormInstanceSections(groupedSections);
				setFormInstanceQuestions(groupedQuestions);
				setLayoutCode(formInstance[0]?.LayoutCode);
			}
		});
	};
};
